import { toBaseStudyEntity } from './study-entity.js';
import { checkLengthInRange } from 'faro-common-model';
import { toStudyDefinitionSource } from './study-definition-source.js';
import { toSystemDefinedObject } from './system-defined-object.js';
import { StudyEntityType } from './study-entity-type.js';
export const studyTitleAcronymMaxLength = 20;
export const studyTitleLongMaxLength = 1000;
export const studyTitleShortMaxLength = 250;
/**
 * This value is used in a study definition's `source` property when it is imported from a `.json` file.
 */
export const studySourceImportedText = 'imported';
/**
 * @return the built Study entity
 */
export function toStudy(study) {
    var _a;
    return {
        ...toBaseStudyEntity(study, StudyEntityType.Study),
        program: study.program,
        type: study.type,
        name: study.name,
        diseaseArea: study.diseaseArea != null ? toSystemDefinedObject(study.diseaseArea) : undefined,
        otherDiseaseAreaIds: study.otherDiseaseAreaIds || [],
        therapeuticArea: study.therapeuticArea != null ? toSystemDefinedObject(study.therapeuticArea) : undefined,
        titleLong: study.titleLong,
        titleShort: study.titleShort,
        titleAcronym: study.titleAcronym,
        phase: study.phase != null ? toSystemDefinedObject(study.phase) : undefined,
        phaseIds: study.phaseIds || [],
        participatingCountryIds: study.participatingCountryIds || [],
        externalId: study.externalId,
        number: study.number,
        userVersion: study.userVersion,
        croVendor: study.croVendor,
        centralLab: study.centralLab,
        edcVendor: study.edcVendor,
        status: study.status,
        isAdaptive: study.isAdaptive || false,
        parentStudyId: study.parentStudyId,
        childStudyIds: study.childStudyIds,
        lastUpdatedBy: study.lastUpdatedBy,
        source: study.source == null ? undefined : toStudyDefinitionSource(study.source),
        metadata: (((_a = study.metadata) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0
            ? study.metadata.reduce((metadata, tuple) => {
                checkLengthInRange(tuple[0], 'Study', 'metadata name', 50, 0);
                checkLengthInRange(tuple[1], 'Study', 'metadata value', 100, 0);
                metadata.push(tuple);
                return metadata;
            }, [])
            : [],
    };
}
//# sourceMappingURL=study.js.map